import { render, staticRenderFns } from "./RawJson.vue?vue&type=template&id=2607f53e&scoped=true&"
import script from "./RawJson.vue?vue&type=script&lang=ts&"
export * from "./RawJson.vue?vue&type=script&lang=ts&"
import style0 from "./RawJson.vue?vue&type=style&index=0&id=2607f53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607f53e",
  null
  
)

export default component.exports